export var appStrings = {
    modules: {
        backrsSidebar: {
            backrs: 'backrs',
            search: 'Search',
        },
        comingSoon: {
            title: 'Page Coming Soon',
        },
        notFound404: {
            title: 'Page not Found',
            action: 'Go Home',
        },
        login: {
            phonePlaceholder: 'Mobile number',
            emailPlaceholder: 'Email',
            passwordPlaceholder: 'Password',
            forgotPassword: 'Forgot Password?',
            backrsLogoAlt: 'Backrs logo',
            getStartedPrompt: 'Log in or sign up to get started.',
            getStartedButton: 'sign up',
            forgotPasswordPrompt: 'Please enter your email address and we will send you a link to reset your password.',
            forgotPassowordButton: 'Send',
            forgotPasswordSuccess: 'If you have an account, you will receive an email to reset your password.',
            error: {
                invalidPhone: 'Please enter a valid phone number',
                invalidEmail: 'Please enter a valid email',
                emailRequired: 'Email is required',
                passwordRequired: 'Password is required',
                phoneEmailRequired: 'Phone number or email is required',
                login: {
                    userNameOrPassword: 'Log in failed: Invalid username or password',
                    phone: 'Log in failed: Invalid phone number',
                    genericError: 'An error occurred while logging in. Please try again or contact an administrator for assistance.',
                },
            },
            otp: {
                title: 'Enter the verification code we just texted you',
                noCode: "Don't see a code?",
                logIn: 'Log In',
                resendCode: 'Enter your phone number to resend your verification code.',
                contactSupportPrompt: 'Still not working? ',
                contactSupportButton: 'Contact support.',
            },
        },
        register: {
            title: 'Join the community',
            confirmAge: 'I certify that I am 14 years of age or older.',
            termsPrompt: 'By registering, I accept Backrs Terms & Conditions',
            termsButton: 'Backrs Terms & Conditions',
            firstNamePlaceholder: 'First Name',
            lastNamePlaceholder: 'Last Name',
            phonePlaceholder: 'Phone Number',
            emailPlaceholder: 'Email',
            passwordPlaceholder: 'Password',
            inviteCodePlaceholder: 'Invite Code (if applicable)',
            buttonLabel: 'Save & Continue',
            ageCertification: 'I certify that I am 14 years of age or older.',
            error: {
                invalidPhone: 'Please enter a valid phone number',
                invalidEmail: 'Please enter a valid email',
                firstNameRequired: 'First name is required',
                lastNameRequired: 'Last name is required',
                emailRequired: 'Email is required',
                phoneRequired: 'Phone number is required',
                passwordRequired: 'Password is required',
                login: {
                    userNameOrPassword: 'Log in failed: Invalid username or password',
                    phone: 'Log in failed: Invalid phone number',
                    genericError: 'An error occurred while logging in. Please try again or contact an administrator for assistance.',
                },
            },
        },
        charts: {
            returnOnInvestment: {
                average: 'Average',
                title: '14-Year Estimated Return on Investment',
                tooltip: "ROI (Return on Investment) is a way to measure how much money you gained or lost compared to how much you started with, expressed as a percentage.\n\nFor example, a 100% ROI means you doubled your investment. This means that the total return is equal to the original amount you invested.\n\nFor example, if you invested $1,000 and got back $2,000 (including your original investment), your ROI would be 100% because you made an additional $1,000 profit on top of your initial investment.",
                yAxisLabel: 'Cumulative Return',
                xAxisLabel: 'Year',
                rankedAverageLegend: 'Ranked Average',
                rankedAverageTooltip: "The Ranked Average represents the mean 14-year ROI of the top 50 colleges based on ROI performance. It reflects the typical financial return students can expect after accounting for tuition and opportunity costs. This figure serves as a benchmark for evaluating the long-term economic value of attending different institutions.",
                chipLabel: function (total_roi, average_roi) {
                    if (total_roi > average_roi) {
                        return "".concat(total_roi - average_roi, "% higher than average");
                    }
                    if (total_roi < average_roi) {
                        return "".concat(average_roi - total_roi, "% lower than average");
                    }
                    return 'Equal to average';
                },
            },
        },
        nugget: {
            eventSubtext: 'Date:',
            opportunitySubtext: 'Deadline:',
            dialogNuggetActions: {
                bookmark: 'Bookmark',
                share: 'Share',
                copyLink: 'Copy Link',
                linkCopied: 'Link copied!',
                markDone: 'Mark as done',
                markComplete: 'Mark complete',
                explainFitScore: 'Explain my fit score',
            },
            internship: {
                notAvailable: 'N/A',
                askLubav: {
                    amIAGoodFit: 'Am I a good fit?',
                    increaseMyOdds: 'Increase my odds',
                    similarRoles: 'Similar roles',
                },
                SECTION_TITLES: {
                    quickLook: 'Quick Look',
                    backrsAssessment: 'Backrs Assessment',
                    applicationLink: 'Application Link',
                },
                QUICK_LOOK: {
                    type: 'Type:',
                    path: 'Path:',
                    track: 'Track:',
                    location: 'Location:',
                    deadline: 'Deadline:',
                    industry: 'Industry:',
                },
                BACKRS_ASSESSMENT: {
                    growthPotential: 'Growth Potential:',
                    compensation: 'Compensation:',
                    intensity: 'Intensity:',
                    gpaRequirement: 'Real GPA required:',
                    achievementRequirement: 'Achievement required:',
                    experienceRequirement: 'Experience:',
                    technicalSkills: 'Technical skills:',
                },
            },
            scholarship: {
                SECTION_TITLES: {
                    awardRange: 'Award Range',
                    applicationDeadline: 'Application Deadline',
                    previousYear: 'Previous Year',
                    awardCategory: 'Award Category',
                    description: 'Description',
                    eligibilityRequirements: 'Eligibility Requirements & Program Restrictions',
                    howToApply: 'How to Apply',
                    applicationRequirements: 'Application Requirements',
                    applicationSubmission: 'Application Submission',
                    applicationDates: 'Application Dates',
                    applicationFee: 'Application Fee',
                    awardContact: 'Award Contact Information',
                },
                AWARD_INFO: {
                    AWARD_RANGE: 'Award Range:',
                    AWARD_TYPE: 'Award Type:',
                    APPLICATION_DEADLINE: 'Application Deadline:',
                    PREVIOUS_YEAR: 'Previous Year:',
                    AWARDS: 'awards',
                    AWARD_CATEGORY: 'Award Category:',
                    DESCRIPTION: 'Description:',
                },
                ELIGIBILITY_REQUIREMENTS_STRINGS: {
                    LEVEL_OF_STUDY_FRONT: 'Award for use during',
                    LEVEL_OF_STUDY_END: 'years of study',
                    INSTITUTION_TYPE: 'Students attending',
                    LIMITED_HS: 'High school students can apply',
                    TEST_SCORE: 'Test Score Requirement:',
                    AGE: 'Age:',
                    GENDER: 'Gender:',
                    MARITAL_STATUS: 'Marital Status:',
                    RACE_ETHNICITY: 'Race/Ethnicity:',
                    DISABILITY_TYPE: 'Disability Type:',
                    MILITARY_SERVICE: 'Military Service:',
                    SEPT_ELEVEN_RESTRICTION: '9/11 survivors/descendants',
                    HERITAGE: 'Heritage:',
                    CITIZENSHIP: 'Citizenship:',
                    RELIGIOUS_AFFILIATION: 'Denominations:',
                    TALENT: 'Talent:',
                    CLUB_MEMBERSHIP: 'Members of:',
                    AREA_OF_STUDY: 'Field of study:',
                    STATE_RESIDENCE: 'Residents of:',
                    STATE_USAGE: 'Usable in:',
                    COUNTY_RESIDENCE: 'County restrictions:',
                    INSTITUTION: 'Restricted to:',
                    CORP_AFFILIATION: 'Corporate affiliation:',
                    EMPLOYMENT: 'Employment:',
                },
                HOW_TO_APPLY_STRINGS: {
                    SUBMISSION_START: 'Submission Start Date:',
                    SUBMISSION_DEADLINE: 'Submission Deadline:',
                    CONTACT: 'Contact:',
                },
            },
            askLubav: {
                backrsProfile: 'Backrs profile',
                blueprint: 'Blueprint',
                networks: 'Networks',
                prosper: 'Prosper',
                errors: {
                    COMING_SOON: 'Coming soon!',
                    NOT_LOGGED_IN: 'You must be logged in to use this feature!',
                    RESUME_REQUIRED: 'To use this feature, please upload your resume to your ',
                    BLUEPRINT_REQUIRED: 'You must have completed a blueprint to use this feature. You can do so by navigating to ',
                    DEFAULT: "We're experiencing exceptionally high demand at the moment. Please check back in a few minutes! In the meantime, check out ",
                },
            },
            careerPath: {
                suggestedFits: {
                    strong: 'Strong',
                    medium: 'Medium',
                    low: 'Low',
                },
                earlyCareerHires: 'Early-career hires per year',
                skilled: 'Skilled/Technical',
                professional: 'Professional',
                growth: 'Growth',
                ai_disruption: 'AI Disruption',
                insight: 'Insight',
                careerTrackDistribution: 'Career Track Distribution',
                semiSkilled: 'Semi-Skilled',
                tradesTechnical: 'Trades/Technical',
                middleTier: 'Middle-Tier Pro',
                upperTier: 'Upper-Tier Pro',
                topTier: 'Top-Tier Pro',
                opportunities: 'Opportunities',
                profiles: 'Profiles',
                employers: 'Employers',
                comingSoon: 'coming soon',
                threeRoles: function (careerPath) { return "3 ".concat(careerPath.toLowerCase(), " roles for me"); },
                rolesByTrack: 'Job roles by track',
                compensationPotential: '$$ potential',
                requirements: 'How to succeed',
                aiDisruption: 'AI disruption',
                onTrack: 'Am I on track?',
            },
            textResponseDaysAgo: 'days ago',
        },
        tour: {
            showTour: 'Show Tour',
            leaveTour: 'Leave Tour',
        },
    },
    buttonText: {
        letsGo: "Let's go!",
        login: 'Log In',
        viewMore: 'View More +',
        viewLess: 'View Less -',
    },
};
